import { render, staticRenderFns } from "./otp-verification-form.vue?vue&type=template&id=b5e8623a&scoped=true"
import script from "./otp-verification-form.vue?vue&type=script&lang=ts"
export * from "./otp-verification-form.vue?vue&type=script&lang=ts"
import style0 from "./otp-verification-form.vue?vue&type=style&index=0&id=b5e8623a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e8623a",
  null
  
)

export default component.exports